import store from 'store';
import { apiClient } from 'v4/core/apiClient';
import { myReduxProxy } from 'v5/api/_common/reduxProxy.connected';
import { myMessageService } from 'v5/services/internal/MessageService/MessageService.connected';
import { createResourceGroupsMutationService } from './ResourceGroupsMutationService.impl';

// Shared by the legacy settings page and the enterprise resource-type tab.
export const myResourceGroupsMutationService =
  createResourceGroupsMutationService({
    client: apiClient,
    reduxProxy: myReduxProxy,
    services: { messageService: myMessageService },
    resolveGroup: id => store.getState().groups.data[id]
  });
